import React from 'react';
import Section from '../shared/Section';


function HeadphoneBody(props) {
    return (
        <div>
            <Section />
        </div>
    )
}



export default HeadphoneBody

